import Main from "../components/main.svelte";

new Main({
  target: document.querySelector('.svelte-goes-here'),
});
